import LocalizedStrings from "react-localization";
import error from "./error";
import modal from "./modal";
import snackbar from "./snackbar";

export const DEFAULT_LANG = "ko" as const;

const translate = {
  ko: {
    ...error.ko,
    ...modal.ko,
    ...snackbar.ko,
  },
  en: {
    ...error.en,
    ...modal.en,
    ...snackbar.en,
  },
};

export default new LocalizedStrings(translate);
